import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { SearchService } from '../../services/search.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-siguiendo',
  templateUrl: './siguiendo.component.html',
  styleUrls: ['./siguiendo.component.scss'],
})
export class SiguiendoComponent implements OnInit {

  private id:number;
  private auth_key:string;
  displayUserData:any;
  following:any=[]; 

  constructor(
    private navParams: NavParams,
    private searchService: SearchService,
    private authService: AuthService,
    private modalCtrl: ModalController
  ) {
    if(navParams.get('show')){
      
    }
   }

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      if(!this.displayUserData){        
        this.displayUserData =  res;
        this.loadVariables();
      }
    });
  }

  loadVariables(){
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
    this.getFollowing();
  }

  getFollowing(){
    this.searchService.getFollowing(this.id,this.auth_key).subscribe((res)=>{
      this.following = res;
    });
  }

  close(){
    this.modalCtrl.dismiss();
  }

}
